

















































import { Component, Vue, Prop } from "vue-property-decorator";
import { Controller } from "@/domainproject/controller";
import { Filter, FilterJson } from "@/domainproject/filter";
import {
  NullableRangeParameter,
  KeywordParameter
} from "@/domainproject/parameter";
import { Color } from "@/domainproject/colors";
import { $_FILTERS, deserializeFilter } from "@/domainproject/filters/all";
import NullableRange from "@/components/NullableRange.vue";
import Sidebar from "@/components/Sidebar.vue";

@Component({
  components: { NullableRange, Sidebar }
})
export default class Filters extends Vue {
  @Prop() controller!: Controller;

  filters: Filter[] = [];

  addFilter(params: { filter: string; color: Color }) {
    const filter: Filter = new ($_FILTERS.get(params.filter))();
    filter.$_color = params.color;
    this.filters.push(filter);
    this.$emit("input", this.filters);
  }

  get NullableRangeParameter() {
    return NullableRangeParameter;
  }

  updateFilters(filters: Filter[], history = true) {
    this.filters = filters;
    if (history) this.$emit("input", this.filters);
  }

  close(uniqueId: number) {
    this.filters = this.filters.filter(x => x.$_uniqueId != uniqueId);
    this.$emit("input", this.filters);
  }
}
